const adaptPsbRequestBody = (body) => ({
  params: { ...body },
});

export default adaptPsbRequestBody;
